enum _PageRoutes {
  Home = '/',
  Cloud = '/cloud',
  GoodDetail = '/good-detail',
  Order = '/order',
  OrderDetail = '/order-detail',
  Income = '/income',
  Calculator = '/calculator',
  ServiceAgreement = '/service-agreement', // 服务协议
  PrivacyPolicy = '/privacy-policy', // 隐私协议
  Disclaimer = '/disclaimer', // 免责声明
  LegalEntity = '/legal-entity', // 法定声明
}

const cloudRouteModule = import.meta.env.VITE_CLOUD_ROUTE_MODULE

/** 拦截，如果是在云算力模块，则返回云算力模块的路径， 如果是在topcredit, 需要拼接一个cloud模块的路径 */
export const PageRoutes = !cloudRouteModule
  ? _PageRoutes
  : new Proxy(_PageRoutes, {
      get(target, p, receiver) {
        const data: string = Reflect.get(target, p, receiver)
        return `${cloudRouteModule}${data}`
      },
    })
